/* eslint-disable react/prop-types */
import { useEffect, useRef } from "react";

// Domyślny wygląd pola (padding, brak ramki, przezroczyste tło, dziedziczenie fontu i koloru, ...)
// jest w regule `textarea:where(.inline-edit)` w index.css, a NIE w stylu inline. Styl inline wygrywa
// z klasami, więc domyślne wartości podane inline nadpisywały klasy szablonów (gradientowe napisy
// w Baśniach 2 i 3 stawały się niewidoczne, znikały kolory z klas), a `font: inherit` kasował
// lineHeight podany przez szablon (cyfra "1" w Baśni 41 wędrowała w górę).
export const InlineEdit = ({ value, setValue, fieldName = 'field', classes = '', style }) => {
    const ref = useRef(null);

    const onChange = (event) => setValue(event.target.value);

    // Auto-dopasowanie wysokości do treści, żeby długi tekst się NIE OBCINAŁ.
    // Wcześniej był tu <input type="text">, który z natury jest jednolinijkowy i tnie
    // tekst po szerokości — efekt: w PDF-ie znikał początek napisu w kreatorach WZ9/WZ10.
    // Textarea zawija tekst i razem z auto-resize'em poniżej rośnie pionowo z treścią.
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = el.scrollHeight + 'px';
    }, [value]);

    return (
        <textarea
            ref={ref}
            rows={1}
            className={'inline-edit ' + classes}
            aria-label={fieldName}
            value={value}
            style={style}
            onChange={onChange}
        />
    );
};
